module.exports = __webpack_public_path__ + "img/snacks-banner-h5-clean.648652dc.png";